/* AX9 FÓRMULA — global behaviour (mobile menu, cart trigger, before/after, gallery, analytics hooks).
   No business data lives here: all content comes from Shopify. */
(() => {
  'use strict';

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------- Mobile menu ---------- */
  let lastTrigger = null;

  function openMenu(menu, trigger) {
    lastTrigger = trigger || null;
    menu.removeAttribute('inert');
    menu.setAttribute('data-open', '');
    document.documentElement.classList.add('ax9-lock');
    document.querySelectorAll('[data-ax9-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const first = menu.querySelector(FOCUSABLE);
    if (first) requestAnimationFrame(() => first.focus());
  }

  function closeMenu(menu) {
    if (!menu.hasAttribute('data-open')) return;
    menu.removeAttribute('data-open');
    menu.setAttribute('inert', '');
    document.documentElement.classList.remove('ax9-lock');
    document.querySelectorAll('[data-ax9-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ax9-menu-open]');
    if (opener) {
      const menu = document.getElementById(opener.getAttribute('aria-controls'));
      if (menu) openMenu(menu, opener);
      return;
    }
    const menu = event.target.closest('[data-ax9-menu]');
    if (menu && (event.target.closest('[data-ax9-menu-close]') || event.target.closest('a[href]'))) {
      closeMenu(menu);
    }
  });

  document.addEventListener('keydown', (event) => {
    const menu = document.querySelector('[data-ax9-menu][data-open]');
    if (!menu) return;
    if (event.key === 'Escape') {
      closeMenu(menu);
      return;
    }
    if (event.key === 'Tab') {
      const items = [...menu.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // Close the menu if the viewport grows to desktop while it is open.
  window.matchMedia('(min-width: 981px)').addEventListener('change', (mq) => {
    if (mq.matches) document.querySelectorAll('[data-ax9-menu][data-open]').forEach(closeMenu);
  });

  /* ---------- Cart button: open Horizon's native cart drawer ---------- */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ax9-cart-drawer]');
    if (!trigger) return;
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open();
    }
    // Otherwise the link goes to /cart (native cart page).
  });

  /* ---------- Before / after sliders (native range input: mouse, touch, keyboard) ---------- */
  document.addEventListener('input', (event) => {
    const range = event.target.closest('.ax9-ba__range');
    if (!range) return;
    range.closest('[data-ax9-ba]')?.style.setProperty('--baw', `${range.value}%`);
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-ax9-pdp-thumb]');
    if (!thumb) return;
    const main = thumb.closest('.ax9-pdp')?.querySelector('.ax9-pdp__img');
    if (!main) return;
    main.src = thumb.dataset.src;
    main.srcset = thumb.dataset.srcset;
    main.alt = thumb.dataset.alt;
    thumb.closest('ul').querySelectorAll('[data-ax9-pdp-thumb]').forEach((b) => b.removeAttribute('aria-current'));
    thumb.setAttribute('aria-current', 'true');
  });

  /* ---------- Analytics hooks ----------
     Every element with data-ax9-track publishes a Shopify custom event
     (visible in Settings › Customer events) and a DOM event for other integrations. */
  document.addEventListener('click', (event) => {
    const el = event.target.closest('[data-ax9-track]');
    if (!el) return;
    const detail = {
      label: el.getAttribute('data-ax9-track'),
      text: (el.textContent || '').trim().slice(0, 120),
      href: el.getAttribute('href') || null,
      page: window.location.pathname,
    };
    const name = detail.label === 'stand' ? 'ax9_stand_click' : 'ax9_cta_click';
    try {
      window.Shopify?.analytics?.publish?.(name, detail);
    } catch (_) {
      /* analytics must never break navigation */
    }
    document.dispatchEvent(new CustomEvent('ax9:track', { detail: { name, ...detail } }));
  });
})();
